import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      inputType: 'section',
      title: 'Properties',
      span: 'full',
    },
  }
}

export const defaultProperties = (): Record<string, any> => {
  return {}
}
